import Resource from '@/plugins/sdk/Resource'
import { STRING, UUID } from '@/plugins/sdk/fields'

export default class extends Resource {
  static name = 'dictionary_crmactype'

  static get fields () {
    return {
      id: new UUID(),
      short: new STRING(),
      long: new STRING(),
      def: new STRING(),
      badgetxt: new STRING(),
      badgecss: new STRING()
    }
  }
}
